'use client';
import { SegmentedControl } from '@/components/ui';
import type { Segment } from '@/components/ui';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import translations from '../AchievementsScreen.translations';

const CATEGORIES = ['all', 'cases', 'upgrades', 'contracts', 'deposits', 'steam', 'friends', 'activity', 'secret', 'rushmid', 'casebattle'] as const;
export type Category = (typeof CATEGORIES)[number];

interface Props {
  active: Category;
  onChange: (cat: Category) => void;
}

const tabLabelKey: Record<Category, keyof typeof translations.en> = {
  all: 'categoryAll',
  cases: 'categoryCases',
  upgrades: 'categoryUpgrades',
  contracts: 'categoryContracts',
  deposits: 'categoryDeposits',
  steam: 'categorySteam',
  friends: 'categoryFriends',
  activity: 'categoryActivity',
  secret: 'categorySecret',
  rushmid: 'categoryRushmid',
  casebattle: 'categoryCasebattle',
};

export function AchievementTabs({ active, onChange }: Props) {
  const { t } = useLocalTranslation(translations);
  const tabs: Segment<Category>[] = CATEGORIES.map((c) => ({
    id: c,
    label: t(tabLabelKey[c]),
  }));
  return <SegmentedControl segments={tabs} value={active} onChange={onChange} className="px-4 py-2" />;
}
